import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { MainLayoutComponent } from './_layout/main-layout/main-layout.component';
import { StsComponent } from './sts/sts.component';
import { ClientsComponent } from './clients/clients.component';
import { DownloadsComponent } from './downloads/downloads.component';

const children = [
  {
    path: '',
    component: StsComponent,
    children: [
      {path: '', component: StsComponent},
      {path: 'auth', component: StsComponent},
      {path: 'logs', component: StsComponent},
      {path: 'keymgmt', component: StsComponent},
      {path: 'start', component: StsComponent},
      {path: 'transfers', component: StsComponent}
    ]
  },
  {
    path: 'clients',
    component: ClientsComponent,
    children: [
      {path: '', component: ClientsComponent},
      {path: 'imgsigner', component: ClientsComponent},
      {path: 'cli', component: ClientsComponent},
      {path: 'rest', component: ClientsComponent},
      {path: 'dotnet', component: ClientsComponent},
      {path: 'nodejs', component: ClientsComponent},
      {path: 'python', component: ClientsComponent},
    ]
  },
  {
    path: 'products',
    component: DownloadsComponent,
    children: [
      {path: '', component: DownloadsComponent},
      {path: 'imgsigner', component: DownloadsComponent},
      {path: 'dotnet', component: DownloadsComponent},
      {path: 'nodejs', component: DownloadsComponent},
      {path: 'python', component: DownloadsComponent},
    ]
  },
];

const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children
  },
  {
    path: '**',
    redirectTo: '/'
  }
];

const routerOptions: ExtraOptions = {
  useHash: false,
  anchorScrolling: 'enabled',
  onSameUrlNavigation: 'reload'
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
